import { useEffect, useState } from 'react';

const planNames = {
  'career-destination': 'Career Destination Session',
  'navigator': 'HSCN Navigator',
  'navigator-plus': 'HSCN Navigator Plus',
};

export default function PaymentSuccess() {
  const [status, setStatus] = useState('verifying');
  const [plan, setPlan] = useState('');
  const [reference, setReference] = useState('');

  useEffect(() => {
    // Get reference from URL query string e.g. /payment/success?reference=CGPS-xxx
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('reference');
    if (!ref) {
      setStatus('failed');
      return;
    }
    setReference(ref);

    fetch(`/api/paystack/verify?reference=${ref}`)
      .then(r => r.json())
      .then(data => {
        if (data.success) {
          setPlan(data.plan);
          setStatus('success');
        } else {
          setStatus('failed');
        }
      })
      .catch(() => setStatus('failed'));
  }, []);

  return (
    <div style={{
      maxWidth: 520,
      margin: '80px auto',
      textAlign: 'center',
      padding: '32px 24px',
      fontFamily: 'sans-serif',
    }}>

      {status === 'verifying' && (
        <>
          <div style={{ fontSize: 56 }}>⏳</div>
          <h2 style={{ color: '#1a3a6c', marginTop: 16 }}>Verifying your payment...</h2>
          <p style={{ color: '#666', fontSize: 14 }}>Please do not close this window.</p>
        </>
      )}

      {status === 'success' && (
        <>
          <div style={{ fontSize: 64 }}>🎉</div>
          <h2 style={{ color: '#1a3a6c', marginTop: 16 }}>Payment Confirmed!</h2>
          <div style={{
            background: '#f0f7ff',
            border: '1px solid #1a3a6c',
            borderRadius: 10,
            padding: '16px 20px',
            margin: '20px 0',
            fontSize: 14,
            color: '#1a3a6c',
            lineHeight: 1.8,
          }}>
            <strong>Welcome to {planNames[plan]}.</strong><br />
            Stanford will be in touch within 24 hours to schedule your first session.<br />
            Please check your email — your confirmation is on its way.
          </div>
          <p style={{ fontSize: 13, color: '#666', marginTop: 16 }}>
            Need help immediately?<br />
            <strong>WhatsApp: +27 68 628 7976</strong>
          </p>
        </>
      )}

      {status === 'failed' && (
        <>
          <div style={{ fontSize: 56 }}>❌</div>
          <h2 style={{ color: '#c0392b', marginTop: 16 }}>Payment could not be confirmed</h2>
          <div style={{
            background: '#fff5f5',
            border: '1px solid #e74c3c',
            borderRadius: 10,
            padding: '16px 20px',
            margin: '20px 0',
            fontSize: 14,
            color: '#666',
            lineHeight: 1.8,
          }}>
            If your payment went through, don't worry.<br />
            WhatsApp Stanford directly with your reference number:<br />
            <strong style={{ color: '#1a3a6c' }}>{reference}</strong>
          </div>
          <p style={{ fontSize: 13, color: '#666' }}>
            <strong>WhatsApp: +27 68 628 7976</strong>
          </p>
        </>
      )}

    </div>
  );
}
